 <circle-progress
[percent]="displayCompletedPct"
></circle-progress>
 <ng-container *ngIf="showProgressBarAndTimeLeft && (minutesLeft != null || secondsLeft != null)">
    <div  class="circle-progress-time-container">

        <div *ngIf="minutesLeft != undefined && minutesLeft != '00'">
            &nbsp;{{minutesLeft}}&nbsp;{{"translate.general.minutes" | translate }} 
        </div>
        <div *ngIf="minutesLeft == '00' && secondsLeft != '00' && secondsLeft != undefined">
            &nbsp;{{secondsLeft}}&nbsp;{{"translate.general.seconds" | translate }}

        </div>
        <div>
            &nbsp;{{"translate.general.left" | translate }}
        </div>
    </div>
    <!-- <p-progressBar [value]="displayCompletedPct"/>
 -->
</ng-container>

<!-- 03:00:00 -->
